import React, { useState, useEffect } from "react";

function calculateTimeLeft() {
    const wedding = new Date("2026-08-15T15:00:00");
    const now = new Date();
    const diff = wedding - now;

    if (diff <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
        days:    Math.floor(diff / 86400000),
        hours:   Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
    };
}

function Countdown() {
    // Oblicz od razu przy pierwszym renderze — bez opóźnienia!
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const pad = (n, len = 2) => String(n).padStart(len, "0");

    return (
        <div className="countdown">
            <span className="cd-label">Do ślubu pozostało…</span>
            <div className="cd-numbers">
                <div className="cd-item">
                    <span className="cd-num">{pad(timeLeft.days, 3)}</span>
                    <span className="cd-unit">Dni</span>
                </div>
                <div className="cd-item">
                    <span className="cd-num">{pad(timeLeft.hours)}</span>
                    <span className="cd-unit">Godzin</span>
                </div>
                <div className="cd-item">
                    <span className="cd-num">{pad(timeLeft.minutes)}</span>
                    <span className="cd-unit">Minut</span>
                </div>
                <div className="cd-item">
                    <span className="cd-num">{pad(timeLeft.seconds)}</span>
                    <span className="cd-unit">Sekund</span>
                </div>
            </div>
        </div>
    );
}

export default Countdown;